import React from 'react'
import { MAX_HIT_COUNT } from '@/lib/constants'
import { ZONE_IDS_LIST } from '@/domain/segment/constants'
import { isNonEmptyArray } from '../../utils/checks'
import CenterCarousel from '@/components/molecules/CenterCarousel/CenterCarousel'

export default function LocationFeaturedCenters({
  centers,
  ZoneIds,
  noPadding,
  sectionHeading = 'Featured Rehabs',
  containerId = 'featured',
  isInfeed,
  isNationwide = false,
  featuredCentersLoading = false,
  feedPosition,
  term
}) {
  const hideSection = !isNonEmptyArray(centers) && !featuredCentersLoading

  const zoneId = isNationwide ? ZONE_IDS_LIST.Nationwide : ZoneIds.Featured

  if (hideSection) {
    return null
  }

  return (
    <CenterCarousel
      centers={centers?.slice(0, MAX_HIT_COUNT)}
      isLoading={featuredCentersLoading}
      feedPosition={feedPosition}
      containerId={containerId}
      isInfeed={isInfeed}
      isNationwide={isNationwide}
      zoneId={zoneId}
      sectionHeading={sectionHeading}
      noPadding={noPadding}
      hideDescription
      termTitle={term?.title}
    />
  )
}
